import { Link } from "@mui/material";
import styled from "styled-components";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

export const StyledLink = styled(Link)<{ size?: "small" | "medium" | "large"; disabled?: boolean }>`
  ${(props) =>
      props.size === "small"
          ? `
                font-size: 12px;
                line-height: 18px;
            `
          : ``}
  ${(props) =>
      props.size === "medium"
          ? `
                font-size: 14px;
                line-height: 20px;
            `
          : ``}
  ${(props) =>
      props.size === "large"
          ? `
                font-size: 16px;
                line-height: 22px;
            `
          : ``}
  &.MuiTypography-colorPrimary {
    ${(props) => "color: " + (props.disabled ? UIStyleConstants.GRAY_LIGHT_COLOR : UIStyleConstants.BLUE_COLOR)};
  ""
  }
`;
